import {CompanyMinimumRes, UserDetailsMinRes, UserDetailsRes} from '../cp';
import {ProjectRole} from '../../../enums';
import {Type} from 'class-transformer';
import {InvoiceCreateReq} from '../cp/invoice.contract';
import {BaseTaskCreateReq} from './task';
import {TrackerCreateReq} from './tracker/tracker.contract';
import {ProjectMinRes, ProjectTrackerRes} from './tracker/project-tracker';
import moment from "moment";
import {WorkflowStatusMinRes} from './status.contract';
import {
    ColumnType,
    yascAutocomplete,
    yascClassDisplayName,
    yascDisplayName,
    yascFormGrid,
    yascFormIgnore,
    yascOptionsKey,
    yascRequired,
    yascTableColumn,
    yascTableDisplayFn,
    yascTableIgnore
} from '@yasc/yasc-material-components';


@yascClassDisplayName('projectTabTeamTitle')
export class ProjectRoleRes {
    @yascDisplayName('general_backendId')
    @yascFormIgnore()
    @yascTableIgnore(true)
    id!: number

    @Type(() => UserDetailsRes)
    @yascDisplayName('general_employee')
    @yascTableColumn(ColumnType.Autocomplete)
    @yascTableDisplayFn((value?: any) => value?.user?.userName ?? value?.userName ?? '')
    user!: UserDetailsMinRes;

    get username(): string {
        return this.user.userName;
    }

    @yascDisplayName('general_role')
    @yascTableColumn(ColumnType.Select)
    @yascTableDisplayFn((value?: any) => {
        const role = value?.role ?? value;
        return role === undefined || role === null ? '' : ProjectRole[role]?.toString() ?? role.toString();
    })
    role!: ProjectRole;
}

export class ProjectCreateReq extends TrackerCreateReq {
    isActive: boolean = true;
    requireTasks: boolean = false;
    customerId!: number;
    internalName?: string;
    orderNr?: string;
    offerNr?: string;
    comment?: string;
    color?: string;
    nextBill?: any;
    start?: string;
    end?: string;
    projectVolumeBrutto?: number
    toDoGroupId?: number;

    // only used for showing data - ignored by backend
    projectVolumeBruttoOpen: number = 0;

    @Type(() => ProjectTeamMemberReq)
    teamMembers: ProjectTeamMemberReq[] = []

    @Type(() => InvoiceCreateReq)
    invoices: InvoiceCreateReq[] = [];

    @Type(() => BaseTaskCreateReq)
    tasks: BaseTaskCreateReq[] = [];

    constructor(_: Partial<ProjectCreateReq>) {
        super();
    }

    static FromDetails(value: Partial<ProjectTrackerRes>) {
        return new ProjectCreateReq({
            name: value.name,
            offerNr: value.offerNr,
            orderNr: value.orderNr,
            comment: value.comment,
            isActive: value.isActive,
            customerId: value.customer!.id,
            invoices: value.invoices ? value.invoices.map(x => InvoiceCreateReq.FromDetails(x)) : [],
            projectVolumeBrutto: value.projectVolumeBrutto,
            projectVolumeBruttoOpen: value.projectVolumeBruttoOpen,
            teamMembers: value.teamMembers ? value.teamMembers.map(x => ProjectTeamMemberReq.FromDetails(x)) : [],
            workflowId: value.workflow?.id,
            currentStatusId: value.currentWorkflowStatus?.id,
            toDoGroupId: value.toDos?.id
        })

    }

    static FromMinDetails(value: Partial<ProjectMinRes>) {
        return new ProjectCreateReq({
            name: value.name,
            offerNr: value.offerNr,
            orderNr: value.orderNr,
            comment: value.comment,
            isActive: value.isActive,
            customerId: value.customer!.id,
            projectVolumeBrutto: value.projectVolumeBrutto,
            projectVolumeBruttoOpen: value.projectVolumeBruttoOpen,
            currentStatusId: value.currentWorkflowStatus?.id,
            workflowId: value.workflowId,
        })

    }
}


export class ProjectRoleUpdateReq {
    id!: number;
    role!: ProjectRole;

    constructor(id: number, role: ProjectRole) {
        this.id = id;
        this.role = role;
    }
}

abstract class BaseUpdateReq {
    projectId!: number

    constructor(projId: number) {
        this.projectId = projId
    }
}

@yascClassDisplayName('projectTabTeamTitle')
export class ProjectTeamMemberReq {
    @yascDisplayName('general_employee')
    @yascTableColumn(ColumnType.Autocomplete)
    @yascAutocomplete()
    @yascOptionsKey('projectTeamUsers')
    @yascRequired()
    @yascFormGrid({ row: 0, width: 2, fullRow: true })
    userId: number | null;

    @yascDisplayName('general_role')
    @yascTableColumn(ColumnType.Select)
    @yascOptionsKey('projectRoles')
    @yascRequired()
    @yascFormGrid({ row: 1, width: 2, fullRow: true })
    roleId: ProjectRole | null;

    constructor(value: Partial<ProjectTeamMemberReq>) {
        this.userId = value.userId ?? null;
        this.roleId = value.roleId ?? null;
    }

    static FromDetails(value: Partial<ProjectRoleRes>) {
        return new ProjectTeamMemberReq({
            userId: value.user?.id,
            roleId: value.role
        })
    }
}

export class ProjectUpdateReq {
    id!: number;
    name!: string;
    internalName?: string;
    customerId?: number;
    requireTasks: boolean = false;
    orderNr?: string;
    offerNr?: string;
    projectVolumeBrutto: number = 0;
    currentStatusId!: number;
    isActive: boolean = true;
    workflowId!: number;
    comment: string = "";
    start?: string;
    end?: string;
    color?: string;

    @Type(() => ProjectTeamMemberReq)
    teamMembers: ProjectTeamMemberReq[] = []

    _nextBill: any;

    // only used for showing data - ignored by backend
    projectVolumeBruttoOpen: number = 0;

    get nextBill(): any {
        return this._nextBill;
    }

    set nextBill(value: any) {
        this._nextBill = moment(value);
    }

    public FromMinDetails(value: Partial<ProjectMinRes>) {
        console.log(value);
        let test = new ProjectUpdateReq({
            name: value.name,
            offerNr: value.offerNr,
            orderNr: value.orderNr,
            comment: value.comment,
            isActive: value.isActive,
            projectVolumeBrutto: value.projectVolumeBrutto,
            projectVolumeBruttoOpen: value.projectVolumeBruttoOpen,
            currentWorkflowStatus: value.currentWorkflowStatus,
            workflowId: value.workflowId,
            type: value.type,

        })
        console.log(test)
        return test
    }

    constructor(res?: Partial<ProjectTrackerRes>) {
        if (res === undefined || res === null) {
            return
        }
        if (res.id)
            this.id = res.id;
        if (res.customer)
            this.customerId = res.customer.id;
        if (res.orderNr)
            this.orderNr = res.orderNr;
        if (res.offerNr)
            this.offerNr = res.offerNr;
        if (res.projectVolumeBrutto)
            this.projectVolumeBrutto = res.projectVolumeBrutto
        if (res.projectVolumeBruttoOpen)
            this.projectVolumeBruttoOpen = res.projectVolumeBruttoOpen;
        if (res.nextBill)
            this.nextBill = res.nextBill;
        if (res.currentWorkflowStatus)
            this.currentStatusId = res.currentWorkflowStatus.id;
        if (res.name)
            this.name = res.name;
        if (res.isActive)
            this.isActive = res.isActive;
        if (res.requireTasks)
            this.requireTasks = res.requireTasks;
        // if (res.workflow)
        //     this.workflowId = res.workflow.id;
        if(res.workflowId)
            this.workflowId = res.workflowId;
        if (res.comment)
            this.comment = res.comment;
        if (res.teamMembers)
            this.teamMembers = res.teamMembers.map(e => new ProjectTeamMemberReq({userId: e.user.id, roleId: e.role}));
        // Object.assign(this, res)
    }


}

export class ProjectToDoUpdateReq extends BaseUpdateReq {
    toDoGroupId: number | null

    constructor(projId: number, toDoid: number | null) {
        super(projId);
        this.toDoGroupId = toDoid
    }
}

export class ProjectDisplayIdUpdateReq extends BaseUpdateReq {
    newId!: string

    constructor(newId: string, projId: number) {
        super(projId);
        this.newId = newId
    }
}

export class ProjectBillUpdateReq extends BaseUpdateReq {
    billId!: number;

    constructor(billId: number, projId: number) {
        super(projId);
        this.billId = billId
    }
}

export class ProjectSummaryAggregationRes{

}

export class ProjectSummaryGroupingRes{
    availableWorkflows:WorkflowStatusMinRes[] = []
    availableCompanies: CompanyMinimumRes[] = []
}
